/* Only the small click handler loads with product pages. No AI calls on view. */
(() => {
  if (window.zbToolsLoader) return;
  window.zbToolsLoader = true;
  const pending = new WeakMap(), mounted = new WeakMap();
  let styles;
  function css(url) {
    if (styles) return styles;
    styles = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = url;
      link.onload = resolve;
      link.onerror = () => { link.remove(); styles = null; reject(Error('styles')); };
      document.head.append(link);
    });
    return styles;
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-zb-tools] [data-tool]');
    if (!button) return;
    const section = button.closest('[data-zb-tools]'), notice = section.querySelector('.zb-tools-load');
    if (mounted.has(section)) { mounted.get(section).open(button); return; }
    if (pending.has(section)) return;
    notice.hidden = false; notice.textContent = 'Otwieram narzędzie…';
    button.setAttribute('aria-busy', 'true');
    const load = Promise.all([css(section.dataset.styles), import(section.dataset.module)]);
    pending.set(section, load);
    try {
      const [, module] = await load;
      if (!section.isConnected) return;
      const widget = module.mount(section);
      mounted.set(section, widget);
      notice.hidden = true;
      widget.open(button);
    } catch (_) {
      notice.textContent = 'Nie udało się wczytać narzędzia. Kliknij je ponownie, aby spróbować jeszcze raz.';
    } finally {
      button.removeAttribute('aria-busy'); pending.delete(section);
    }
  });
})();
